import React from "react";
import Modal from "../Modal/Modal";
import { ErrorIcon } from "../../../../Assets/svgs";

interface PaymentFailedProps {
  paymentFailed: boolean;
  setPaymentFailed: (value: boolean) => void;
}

const PaymentFailedModal: React.FC<PaymentFailedProps> = ({
  paymentFailed,
  setPaymentFailed,
}) => {
  return (
    <Modal
      isOpen={paymentFailed}
      closable={false}
      onClose={() => setPaymentFailed(false)}
    >
      <div className="payment-failed">
        <img src={ErrorIcon} style={{ height: "70px", objectFit: "contain" }} />
        <div
          style={{
            marginTop: "40px",
            marginBottom: "30px",
            fontFamily: "OggTextMedium",
            fontSize: "20px",
            width: "100%",
            alignSelf: "center",
          }}
        >
          Your Purchase couldn’t be completed due to a payment failure.
          <br />
          <br />
          Please try again to complete the process.
        </div>
        <div
          style={{
            height: "1px",
            width: "100%",
            backgroundColor: "rgba(0,0,0,0.2)",
          }}
        ></div>
        <div
          onClick={() => {
            setPaymentFailed(false);
          }}
          style={{
            backgroundColor: "rgba(36, 109, 194, 1)",
            padding: "10px",
            marginTop: "40px",
            color: "#FFF",
            borderRadius: "8px",
            fontFamily: "OggTextMedium",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          Retry
        </div>
      </div>
    </Modal>
  );
};

export default PaymentFailedModal;
